exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NHLMatchup__header--28qdc {\n  padding-left: 8px;\n  padding-bottom: 8px;\n  font-size: 16px;\n  font-weight: 500;\n  margin: 0;\n}\n\n.NHLMatchup__teamStatsCard--3qGOr {\n  height: 300px;\n}\n\n.NHLMatchup__teamStats--3ZwKb {\n  overflow: hidden;\n}\n\n.NHLMatchup__desktopView--1GspC {\n  display: none;\n}\n\n.NHLMatchup__teamStatsGetTheApp--1_SeD {\n  position: relative;\n  top: -300px;\n}\n\n@media (min-width: 768px) {\n  .NHLMatchup__header--28qdc {\n    font-size: 20px;\n    padding-bottom: 10px;\n  }\n  .NHLMatchup__column--3k1fp {\n    padding-right: 16px;\n  }\n  .NHLMatchup__desktopView--1GspC {\n    display: block;\n  }\n  .NHLMatchup__mobileView--2Pghi {\n    display: none;\n  }\n}", ""]);

// exports
exports.locals = {
	"header": "NHLMatchup__header--28qdc",
	"teamStatsCard": "NHLMatchup__teamStatsCard--3qGOr",
	"teamStats": "NHLMatchup__teamStats--3ZwKb",
	"desktopView": "NHLMatchup__desktopView--1GspC",
	"teamStatsGetTheApp": "NHLMatchup__teamStatsGetTheApp--1_SeD",
	"column": "NHLMatchup__column--3k1fp",
	"mobileView": "NHLMatchup__mobileView--2Pghi"
}; 
var style = module.exports.toString();module.exports = exports.locals || { stylesheet: "" };if (!module.exports.stylesheet) { module.exports.stylesheet = style; };